module.exports = __webpack_public_path__ + "img/3.d4c3b260.jpg";